import { createAsyncThunk } from '@reduxjs/toolkit';
import WhatsAppTemplatesService from '@/services/WhatsAppTemplatesService';

export const getWhatsAppTemplates = createAsyncThunk(
  'WhatsAppTemplates/getWhatsAppTemplates',
  () => WhatsAppTemplatesService.getTemplates()
);

export const getTemplateVariables = createAsyncThunk(
  'WhatsAppTemplates/getTemplateVariables',
  () => WhatsAppTemplatesService.getVariables()
);

export const createWhatsAppTemplate = createAsyncThunk(
  'WhatsAppTemplates/createWhatsAppTemplate',
  (payload) => WhatsAppTemplatesService.createTemplate(payload)
);

export const getWhatsAppTemplate = createAsyncThunk(
  'WhatsAppTemplates/getWhatsAppTemplate',
  (templateId) => WhatsAppTemplatesService.getTemplate(templateId)
);

export const updateWhatsAppTemplate = createAsyncThunk(
  'WhatsAppTemplates/updateWhatsAppTemplate',
  ({ templateId, payload }) =>
    WhatsAppTemplatesService.updateTemplate(templateId, payload)
);

export const assignTemplateParameters = createAsyncThunk(
  'WhatsAppTemplates/assignTemplateParameters',
  ({ templateId, parameters }) =>
    WhatsAppTemplatesService.assignParameters(templateId, parameters)
);

export const deleteWhatsAppTemplate = createAsyncThunk(
  'WhatsAppTemplates/deleteWhatsAppTemplate',
  (templateId) => WhatsAppTemplatesService.deleteTemplate(templateId)
);
